
import { keyBy } from 'lodash';

export const FINANCE_STATUS_ICON_MAP = {
  pending: 'jindu-cu',
  not_paid: 'a-warring-tianchong3',
  Not_paid: 'a-warring-tianchong3',
  part_paid: 'a-warring-tianchong3',
  Part_paid: 'a-warring-tianchong3',
  paid_review: 'jindu-cu',
  Paid_review: 'jindu-cu',
  paid: 'success-tianchong',
  Paid: 'success-tianchong',
  delayed: 'a-warring-tianchong3',
  Delayed: 'a-warring-tianchong3',
}

export const FINANCE_SELLER_STATUS = [
  { label: 'Part Paid', value: 'part_paid' },
  // { label: 'Part Paid', value: 'Part_paid' },
  { label: 'Reviewing', value: 'paid_review' },
  // { label: 'Reviewing', value: 'Paid_review' },
  { label: 'Not Paid', value: 'not_paid' },
  // { label: 'Not Paid', value: 'Not_paid' },
  { label: 'Paid', value: 'paid' },
  // { label: 'Paid', value: 'Paid' },
  { label: 'Delayed', value: 'delayed' },
  // { label: 'Delayed', value: 'Delayed' },
]

export const FINANCE_SELLER_STATUS_MAP = keyBy(FINANCE_SELLER_STATUS, 'value')